import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/loginBg.png';
import _imports_1 from '@/assets/icons/N.png';
const _withScopeId = n => (_pushScopeId("data-v-1afc0f9d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  ref: "loginBox",
  class: "register-login-box"
};
const _hoisted_2 = {
  class: "loginBody"
};
const _hoisted_3 = {
  class: "loginBodyLeft"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "imgBox"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})], -1));
const _hoisted_5 = {
  class: "loginBodyRight"
};
const _hoisted_6 = {
  class: "loginFixd"
};
const _hoisted_7 = {
  class: "fixdItem fixdItem1"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}), /*#__PURE__*/_createTextVNode("　 "), /*#__PURE__*/_createElementVNode("span", {
  class: "fontXB",
  style: {
    "font-size": "22.5px"
  }
}, "Nike Tracking System "), /*#__PURE__*/_createElementVNode("span", {
  class: "fontEX",
  style: {
    "font-size": "22.5px",
    "color": "#282828"
  }
}, "V2.0")], -1));
const _hoisted_9 = {
  class: "fixdItem2"
};
const _hoisted_10 = {
  class: "fontEX"
};
const _hoisted_11 = {
  class: "fontXB"
};
const _hoisted_12 = {
  class: "login-box"
};
const _hoisted_13 = {
  class: "login-tab"
};
const _hoisted_14 = {
  class: "login-content"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "margin_t"
}, null, -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "margin_t"
}, null, -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "margin_t"
}, null, -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "margin_t"
}, null, -1));
const _hoisted_19 = {
  class: "login-bottom"
};
const _hoisted_20 = {
  style: {
    "font-size": "12px",
    "color": "#777777"
  }
};
const _hoisted_21 = {
  class: "login-content"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "margin_t"
}, null, -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "margin_t"
}, null, -1));
const _hoisted_24 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "flex": "1"
  }
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "margin_t"
}, null, -1));
const _hoisted_26 = {
  class: "login-bottom"
};
const _hoisted_27 = {
  style: {
    "font-size": "12px",
    "color": "#777777"
  }
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "margin_t"
}, null, -1));
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "login-bottom"
}, null, -1));
const _hoisted_30 = {
  class: "register-box"
};
const _hoisted_31 = {
  class: "register_title"
};
const _hoisted_32 = {
  class: "bottom"
};
const _hoisted_33 = {
  class: "flex_j_b",
  style: {
    "margin-bottom": "10px"
  }
};
const _hoisted_34 = {
  class: "nameBox"
};
const _hoisted_35 = {
  key: 0
};
const _hoisted_36 = {
  key: 1
};
const _hoisted_37 = {
  class: "flex_j_b"
};
const _hoisted_38 = {
  class: "register-box register-box2"
};
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "margin_two"
}, null, -1));
const _hoisted_40 = {
  class: "form-item-content"
};
const _hoisted_41 = {
  class: "form-item-content"
};
const _hoisted_42 = {
  class: "form-item-content"
};
const _hoisted_43 = {
  class: "form-item-content"
};
const _hoisted_44 = {
  class: "form-item-content"
};
const _hoisted_45 = {
  class: "form-item-content"
};
const _hoisted_46 = {
  class: "form-item-content"
};
const _hoisted_47 = {
  class: "login-box"
};
const _hoisted_48 = {
  class: "step-box"
};
const _hoisted_49 = {
  class: "login-content"
};
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "margin_t"
}, null, -1));
const _hoisted_51 = {
  class: "flex_j_b"
};
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "margin_t"
}, null, -1));
const _hoisted_53 = {
  style: {
    "text-align": "right"
  }
};
const _hoisted_54 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "margin_t"
}, null, -1));
const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "login-bottom"
}, null, -1));
const _hoisted_56 = {
  class: "login-box"
};
const _hoisted_57 = {
  class: "step-box"
};
const _hoisted_58 = {
  class: "login-content"
};
const _hoisted_59 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "margin_t"
}, null, -1));
const _hoisted_60 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "margin_t"
}, null, -1));
const _hoisted_61 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "margin_t"
}, null, -1));
const _hoisted_62 = {
  style: {
    "text-align": "right"
  }
};
const _hoisted_63 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "margin_t"
}, null, -1));
const _hoisted_64 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "login-bottom"
}, null, -1));
const _hoisted_65 = {
  class: "login-box"
};
const _hoisted_66 = {
  class: "step-box"
};
const _hoisted_67 = {
  class: "login-content"
};
const _hoisted_68 = {
  style: {
    "height": "104px",
    "display": "grid",
    "place-items": "center",
    "color": "#83be8a"
  }
};
const _hoisted_69 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "margin_t"
}, null, -1));
const _hoisted_70 = {
  style: {
    "text-align": "right",
    "margin-top": "20px"
  }
};
const _hoisted_71 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "margin_t"
}, null, -1));
const _hoisted_72 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "login-bottom"
}, null, -1));
const _hoisted_73 = {
  class: "login-box"
};
const _hoisted_74 = {
  style: {
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_75 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_76 = {
  style: {
    "font-size": "16px",
    "color": "#777777",
    "font-weight": "bolder"
  }
};
const _hoisted_77 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1"
  }
}, null, -1));
const _hoisted_78 = {
  style: {
    "font-size": "14px",
    "display": "flex",
    "color": "#777"
  }
};
const _hoisted_79 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "login-content"
}, [/*#__PURE__*/_createElementVNode("div", {
  id: "login_container",
  style: {
    "height": "250px",
    "display": "grid",
    "place-items": "center"
  }
})])], -1));
const _hoisted_80 = {
  class: "login-box"
};
const _hoisted_81 = {
  style: {
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_82 = {
  style: {
    "display": "flex",
    "align-items": "end"
  }
};
const _hoisted_83 = {
  style: {
    "font-size": "16px"
  }
};
const _hoisted_84 = {
  style: {
    "font-size": "14px",
    "color": "red",
    "margin-left": "20px"
  }
};
const _hoisted_85 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "border-bottom": "1px solid #898989",
    "width": "100%",
    "margin-top": "10px",
    "margin-bottom": "20px"
  }
}, null, -1));
const _hoisted_86 = {
  class: "login-content"
};
const _hoisted_87 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "margin_t"
}, null, -1));
const _hoisted_88 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "margin_t"
}, null, -1));
const _hoisted_89 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "flex": "1"
  }
};
const _hoisted_90 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "margin_t"
}, null, -1));
const _hoisted_91 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "margin_t"
}, null, -1));
const _hoisted_92 = {
  class: "login-bottom"
};
const _hoisted_93 = {
  class: "signIn"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tailoring = _resolveComponent("Tailoring");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_a_carousel = _resolveComponent("a-carousel");
  const _component_svg_icon = _resolveComponent("svg-icon");
  const _component_a_input = _resolveComponent("a-input");
  const _component_a_form_item = _resolveComponent("a-form-item");
  const _component_a_form = _resolveComponent("a-form");
  const _component_a_checkbox = _resolveComponent("a-checkbox");
  const _component_a_button = _resolveComponent("a-button");
  const _component_el_avatar = _resolveComponent("el-avatar");
  const _component_el_button = _resolveComponent("el-button");
  const _component_DownCircleOutlined = _resolveComponent("DownCircleOutlined");
  const _component_a_select = _resolveComponent("a-select");
  const _component_down_circle_outlined = _resolveComponent("down-circle-outlined");
  const _component_a_tree_select = _resolveComponent("a-tree-select");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_LeftCircleOutlined = _resolveComponent("LeftCircleOutlined");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_dialog, {
    modelValue: $setup.control.avatardialogVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.control.avatardialogVisible = $event),
    title: _ctx.$t('login.hello'),
    style: {
      "min-width": "380px",
      "max-width": "550px",
      "width": "50%"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_Tailoring, {
      onImgUrlbase64: $setup.imgUrlbase64
    }, null, 8, ["onImgUrlbase64"])]),
    _: 1
  }, 8, ["modelValue", "title"]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_a_carousel, {
    dots: true
  }, {
    default: _withCtx(() => [_hoisted_4]),
    _: 1
  })]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_svg_icon, {
    iconName: "enCn",
    onClick: $setup.changeLanguage,
    iconSize: "25px"
  }, null, 8, ["onClick"])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("login.hello")) + ",", 1), _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("login.welcome")) + "!", 1)])]), _withDirectives(_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("span", {
    class: _normalizeClass({
      bottom: $setup.control.loginType === 0
    }),
    onClick: _cache[1] || (_cache[1] = $event => $setup.control.loginType = 0)
  }, _toDisplayString(_ctx.$t("login.userLogin")), 3), _createElementVNode("span", {
    class: _normalizeClass({
      bottom: $setup.control.loginType === 1
    }),
    onClick: _cache[2] || (_cache[2] = $event => $setup.control.loginType = 1)
  }, _toDisplayString(_ctx.$t("login.smsLogin")), 3), _createElementVNode("div", {
    class: "loginQr",
    onClick: _cache[3] || (_cache[3] = (...args) => $setup.onWxLogin && $setup.onWxLogin(...args))
  }, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("login.scanLogin")), 1), _createVNode(_component_svg_icon, {
    iconName: "qrCode",
    iconSize: "22px",
    color: "#777777"
  })])]), _createElementVNode("div", null, [_withDirectives(_createElementVNode("div", _hoisted_14, [_createVNode(_component_a_form, {
    ref: "usernameLoginForm",
    model: $setup.loginFormData,
    rules: $setup.loginFormRules
  }, {
    default: _withCtx(() => [_createVNode(_component_a_form_item, {
      name: "username"
    }, {
      default: _withCtx(() => [_hoisted_15, _createVNode(_component_a_input, {
        value: $setup.loginFormData.username,
        "onUpdate:value": _cache[4] || (_cache[4] = $event => $setup.loginFormData.username = $event),
        placeholder: _ctx.$t('login.enterUsername'),
        size: "large"
      }, null, 8, ["value", "placeholder"])]),
      _: 1
    }), _createVNode(_component_a_form_item, {
      name: "password"
    }, {
      default: _withCtx(() => [_hoisted_16, _createVNode(_component_a_input, {
        value: $setup.loginFormData.password,
        "onUpdate:value": _cache[5] || (_cache[5] = $event => $setup.loginFormData.password = $event),
        type: "password",
        placeholder: _ctx.$t('login.enterPassword'),
        size: "large"
      }, null, 8, ["value", "placeholder"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["model", "rules"]), _hoisted_17, _hoisted_18, _createElementVNode("div", _hoisted_19, [_createVNode(_component_a_checkbox, {
    modelValue: $setup.loginFormData.remember,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $setup.loginFormData.remember = $event),
    label: "",
    size: "small",
    style: {
      "font-size": "14px"
    }
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("login.rememberMe")), 1)]),
    _: 1
  }, 8, ["modelValue"]), _createElementVNode("div", null, [_createElementVNode("span", {
    onClick: _cache[7] || (_cache[7] = $event => {
      $setup.control.loginTab = 3;
      $setup.control.resetPasswordStep = 0;
    }),
    style: {
      "cursor": "pointer",
      "text-align": "end",
      "margin-right": "5px"
    }
  }, _toDisplayString(_ctx.$t("login.forgotPassword")), 1), _createVNode(_component_a_button, {
    class: "sts-button default loginBtn",
    onClick: $setup.onLoginSubmit
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("login.login")), 1)]),
    _: 1
  }, 8, ["onClick"])])])], 512), [[_vShow, $setup.control.loginType === 0]]), _withDirectives(_createElementVNode("div", _hoisted_21, [_createVNode(_component_a_form, {
    ref: "mobileLoginForm",
    model: $setup.loginFormData,
    rules: $setup.loginFormRules
  }, {
    default: _withCtx(() => [_createVNode(_component_a_form_item, {
      name: "mobile"
    }, {
      default: _withCtx(() => [_hoisted_22, _createVNode(_component_a_input, {
        value: $setup.loginFormData.mobile,
        "onUpdate:value": _cache[8] || (_cache[8] = $event => $setup.loginFormData.mobile = $event),
        placeholder: _ctx.$t('login.enterMobile'),
        size: "large"
      }, null, 8, ["value", "placeholder"])]),
      _: 1
    }), _createVNode(_component_a_form_item, {
      name: "smsCode"
    }, {
      default: _withCtx(() => [_hoisted_23, _createElementVNode("div", _hoisted_24, [_createVNode(_component_a_input, {
        value: $setup.loginFormData.smsCode,
        "onUpdate:value": _cache[9] || (_cache[9] = $event => $setup.loginFormData.smsCode = $event),
        placeholder: _ctx.$t('login.enterCode'),
        size: "large",
        style: {
          "flex": "1",
          "margin-right": "10px"
        }
      }, null, 8, ["value", "placeholder"]), _createVNode(_component_a_button, {
        class: "sts-button default loginBtn",
        style: {
          "width": "83.25px",
          "margin-left": "28px"
        },
        disabled: $setup.smsControl.smsDisabled,
        onClick: $setup.onSendSms
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.smsControl.smsButtonText), 1)]),
        _: 1
      }, 8, ["disabled", "onClick"])])]),
      _: 1
    })]),
    _: 1
  }, 8, ["model", "rules"]), _hoisted_25, _createElementVNode("div", _hoisted_26, [_createVNode(_component_a_checkbox, {
    modelValue: $setup.loginFormData.remember,
    "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $setup.loginFormData.remember = $event),
    label: "",
    size: "small",
    style: {
      "font-size": "14px"
    }
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t("login.rememberMe")), 1)]),
    _: 1
  }, 8, ["modelValue"]), _createElementVNode("div", null, [_createVNode(_component_a_button, {
    class: "sts-button default loginBtn",
    onClick: _cache[11] || (_cache[11] = $event => $setup.onLoginSubmit($event, 2))
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("login.login")), 1)]),
    _: 1
  })])]), _hoisted_28, _hoisted_29], 512), [[_vShow, $setup.control.loginType === 1]])])], 512), [[_vShow, $setup.control.loginTab === 0]]), _withDirectives(_createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t("login.newAccount")), 1)]), _createVNode(_component_a_form, {
    model: $setup.registerFormData,
    ref: "registerFormFirst",
    rules: $setup.registerFormRules,
    "label-width": "80px",
    "label-position": "left",
    class: "register-form",
    hideRequiredMark: true
  }, {
    default: _withCtx(() => [_withDirectives(_createVNode(_component_a_form_item, {
      label: _ctx.$t('login.avatar'),
      name: "avatar"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_avatar, {
        size: 50,
        src: $setup.registerFormData.avatar,
        style: {
          "background": "#fff"
        }
      }, null, 8, ["src"]), _createVNode(_component_el_button, {
        onClick: _cache[12] || (_cache[12] = $event => $setup.control.avatardialogVisible = true),
        style: {
          "margin-left": "16px",
          "padding": "0px",
          "min-width": "0px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("login.editAvatar")), 1)]),
        _: 1
      })]),
      _: 1
    }, 8, ["label"]), [[_vShow, false]]), _createElementVNode("div", _hoisted_33, [_createVNode(_component_a_form_item, {
      name: "lastName"
    }, {
      default: _withCtx(() => [_createVNode(_component_a_input, {
        value: $setup.registerFormData.lastName,
        "onUpdate:value": _cache[13] || (_cache[13] = $event => $setup.registerFormData.lastName = $event),
        placeholder: _ctx.$t('login.surname')
      }, null, 8, ["value", "placeholder"])]),
      _: 1
    }), _createVNode(_component_a_form_item, {
      name: "firstName"
    }, {
      default: _withCtx(() => [_createVNode(_component_a_input, {
        onChange: $setup.firstNameChange,
        value: $setup.registerFormData.firstName,
        "onUpdate:value": _cache[14] || (_cache[14] = $event => $setup.registerFormData.firstName = $event),
        placeholder: _ctx.$t('login.name')
      }, null, 8, ["onChange", "value", "placeholder"])]),
      _: 1
    }), _createElementVNode("div", _hoisted_34, [_createElementVNode("p", null, [$setup.cnenBtn === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.$t("login.snFirstGivenLast")), 1)) : _createCommentVNode("", true), $setup.cnenBtn === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.$t("login.givenFirstSnLast")), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_createElementVNode("div", {
      class: _normalizeClass({
        cnenBtn: true,
        cnenBtnCheck: $setup.cnenBtn === 0
      }),
      onClick: _cache[15] || (_cache[15] = $event => $setup.cnenBtn = 0)
    }, _toDisplayString(_ctx.$t("login.zh")), 3), _createElementVNode("div", {
      class: _normalizeClass({
        cnenBtn: true,
        cnenBtnCheck: $setup.cnenBtn === 1
      }),
      onClick: _cache[16] || (_cache[16] = $event => $setup.cnenBtn = 1)
    }, _toDisplayString(_ctx.$t("login.en")), 3)])])]), _createElementVNode("div", _hoisted_37, [_createVNode(_component_a_form_item, {
      label: _ctx.$t('login.userType'),
      name: "type",
      class: "custom-label"
    }, {
      default: _withCtx(() => [_createVNode(_component_a_select, {
        value: $setup.registerFormData.type,
        "onUpdate:value": _cache[17] || (_cache[17] = $event => $setup.registerFormData.type = $event),
        options: $setup.userTypeData,
        style: {
          "width": "150px"
        },
        onChange: _cache[18] || (_cache[18] = $event => $setup.registerFormData.managerId = null)
      }, {
        suffixIcon: _withCtx(() => [_createVNode(_component_DownCircleOutlined, {
          style: {
            "width": "22px",
            "height": "22px",
            "color": "#8b8b8b"
          }
        })]),
        _: 1
      }, 8, ["value", "options"])]),
      _: 1
    }, 8, ["label"]), $setup.registerFormData.type == '1' ? (_openBlock(), _createBlock(_component_a_form_item, {
      key: 0,
      label: _ctx.$t('login.category'),
      name: "managerId",
      class: "custom-label"
    }, {
      default: _withCtx(() => [_createVNode(_component_a_tree_select, {
        value: $setup.registerFormData.managerId,
        "onUpdate:value": _cache[19] || (_cache[19] = $event => $setup.registerFormData.managerId = $event),
        treeData: $setup.organizationData,
        treeDefaultExpandAll: true,
        defaultExpandAll: "",
        fieldNames: $setup.brandProps,
        style: {
          "width": "150px"
        }
      }, {
        suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
          class: "ant-select-suffix"
        })]),
        _: 1
      }, 8, ["value", "treeData", "fieldNames"])]),
      _: 1
    }, 8, ["label"])) : _createCommentVNode("", true), $setup.registerFormData.type == '2' ? (_openBlock(), _createBlock(_component_a_form_item, {
      key: 1,
      label: _ctx.$t('login.category'),
      name: "managerId"
    }, {
      default: _withCtx(() => [_createVNode(_component_a_select, {
        value: $setup.registerFormData.managerId,
        "onUpdate:value": _cache[20] || (_cache[20] = $event => $setup.registerFormData.managerId = $event),
        options: $setup.vendorData,
        "field-names": $setup.vendorProps,
        style: {
          "width": "150px"
        }
      }, {
        suffixIcon: _withCtx(() => [_createVNode(_component_DownCircleOutlined, {
          style: {
            "width": "22px",
            "height": "22px",
            "color": "#8b8b8b"
          }
        })]),
        _: 1
      }, 8, ["value", "options", "field-names"])]),
      _: 1
    }, 8, ["label"])) : _createCommentVNode("", true), $setup.registerFormData.type == '3' ? (_openBlock(), _createBlock(_component_a_form_item, {
      key: 2,
      label: _ctx.$t('login.category'),
      name: "managerId"
    }, {
      default: _withCtx(() => [_createVNode(_component_a_select, {
        filterable: "",
        "popper-select-login": "",
        value: $setup.registerFormData.managerId,
        "onUpdate:value": _cache[21] || (_cache[21] = $event => $setup.registerFormData.managerId = $event),
        options: $setup.storeData,
        "field-names": $setup.storeProps,
        style: {
          "width": "150px"
        }
      }, {
        suffixIcon: _withCtx(() => [_createVNode(_component_DownCircleOutlined, {
          style: {
            "width": "22px",
            "height": "22px",
            "color": "#8b8b8b"
          }
        })]),
        _: 1
      }, 8, ["value", "options", "field-names"])]),
      _: 1
    }, 8, ["label"])) : _createCommentVNode("", true)]), _createVNode(_component_a_form_item, {
      style: {
        "position": "relative"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_a_button, {
        class: "sts-button default loginBtn",
        style: {
          "width": "85px",
          "text-align": "center",
          "float": "right"
        },
        color: "#000000",
        onClick: $setup.onRegisterNext
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("login.nextStep")), 1)]),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["model", "rules"])], 512), [[_vShow, $setup.control.loginTab === 1]]), _withDirectives(_createElementVNode("div", _hoisted_38, [_hoisted_39, _createVNode(_component_a_form, {
    model: $setup.registerFormData,
    ref: "registerForm",
    rules: $setup.registerFormNextRules,
    "label-width": "80px",
    "label-position": "left",
    class: "register-form",
    hideRequiredMark: true
  }, {
    default: _withCtx(() => [_createVNode(_component_a_form_item, {
      label: _ctx.$t('login.contactInfo'),
      name: "mobile",
      class: "custom-label"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_40, [_createVNode(_component_a_input, {
        value: $setup.registerFormData.mobile,
        "onUpdate:value": _cache[22] || (_cache[22] = $event => $setup.registerFormData.mobile = $event),
        placeholder: _ctx.$t('login.enterMobile'),
        class: "longIpt"
      }, null, 8, ["value", "placeholder"])])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_a_form_item, {
      label: _ctx.$t('login.code'),
      name: "smsCode",
      class: "custom-label"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_41, [_createVNode(_component_a_input, {
        value: $setup.registerFormData.smsCode,
        "onUpdate:value": _cache[23] || (_cache[23] = $event => $setup.registerFormData.smsCode = $event),
        placeholder: "",
        class: "shortIpt"
      }, null, 8, ["value"]), _createVNode(_component_a_button, {
        class: "sts-button default loginBtn shortBtn",
        disabled: $setup.smsRegisterControl.smsDisabled,
        onClick: $setup.onSendRegisterSms
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.smsRegisterControl.smsButtonText), 1)]),
        _: 1
      }, 8, ["disabled", "onClick"])])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_a_form_item, {
      label: _ctx.$t('login.email'),
      name: "email",
      class: "custom-label"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_42, [_createVNode(_component_a_input, {
        value: $setup.registerFormData.email,
        "onUpdate:value": _cache[24] || (_cache[24] = $event => $setup.registerFormData.email = $event),
        placeholder: _ctx.$t('login.enterEmail'),
        class: "longIpt"
      }, null, 8, ["value", "placeholder"])])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_a_form_item, {
      label: _ctx.$t('login.code'),
      name: "emailCode",
      class: "custom-label"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_43, [_createVNode(_component_a_input, {
        value: $setup.registerFormData.emailCode,
        "onUpdate:value": _cache[25] || (_cache[25] = $event => $setup.registerFormData.emailCode = $event),
        placeholder: "",
        class: "shortIpt"
      }, null, 8, ["value"]), _createVNode(_component_a_button, {
        class: "sts-button default loginBtn shortBtn",
        disabled: $setup.emailRegisterControl.smsDisabled,
        onClick: $setup.onSendRegisterEmail
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.emailRegisterControl.smsButtonText), 1)]),
        _: 1
      }, 8, ["disabled", "onClick"])])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_a_form_item, {
      label: _ctx.$t('login.accountPassword'),
      name: "password",
      class: "custom-label"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_44, [_createVNode(_component_a_input, {
        value: $setup.registerFormData.password,
        "onUpdate:value": _cache[26] || (_cache[26] = $event => $setup.registerFormData.password = $event),
        type: "password",
        placeholder: _ctx.$t('login.enterPassword'),
        class: "longIpt"
      }, null, 8, ["value", "placeholder"])])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_a_form_item, {
      label: _ctx.$t('login.confirmPwd'),
      name: "passwordAgain",
      class: "custom-label"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_45, [_createVNode(_component_a_input, {
        value: $setup.registerFormData.passwordAgain,
        "onUpdate:value": _cache[27] || (_cache[27] = $event => $setup.registerFormData.passwordAgain = $event),
        type: "password",
        placeholder: _ctx.$t('login.confirmPassword'),
        class: "longIpt"
      }, null, 8, ["value", "placeholder"])])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_a_form_item, null, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_46, [_createVNode(_component_a_button, {
        class: "sts-button default reBtn",
        color: "#000000",
        onClick: $setup.onRegisterSubmit
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("login.finish")), 1)]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_a_button, {
        class: "sts-button default reBtn",
        onClick: _cache[28] || (_cache[28] = $event => $setup.control.loginTab = 1)
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("login.cancel")), 1)]),
        _: 1
      })])]),
      _: 1
    })]),
    _: 1
  }, 8, ["model", "rules"])], 512), [[_vShow, $setup.control.loginTab === 2]]), _withDirectives(_createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_createElementVNode("div", null, _toDisplayString(_ctx.$t("login.forgotPassword")), 1)]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_49, [_createVNode(_component_a_form, {
    ref: "resetPasswordForm",
    model: $setup.resetPasswordFormData,
    rules: $setup.resetPasswordFormRules
  }, {
    default: _withCtx(() => [_createVNode(_component_a_form_item, {
      class: "reset-email",
      label: "",
      name: "email"
    }, {
      default: _withCtx(() => [_hoisted_50, _createVNode(_component_a_input, {
        value: $setup.resetPasswordFormData.email,
        "onUpdate:value": _cache[29] || (_cache[29] = $event => $setup.resetPasswordFormData.email = $event),
        placeholder: _ctx.$t('login.email'),
        size: "large"
      }, null, 8, ["value", "placeholder"])]),
      _: 1
    }), _createVNode(_component_a_form_item, {
      label: "",
      name: "emailCode"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_51, [_createVNode(_component_a_input, {
        value: $setup.resetPasswordFormData.emailCode,
        "onUpdate:value": _cache[30] || (_cache[30] = $event => $setup.resetPasswordFormData.emailCode = $event),
        placeholder: _ctx.$t('login.code'),
        style: {
          "width": "75%"
        }
      }, null, 8, ["value", "placeholder"]), _createVNode(_component_a_button, {
        class: "button-default loginBtn",
        disabled: $setup.resetPasswordControl.smsDisabled,
        onClick: $setup.onSendResetPassword,
        color: "#000000"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.resetPasswordControl.smsButtonText), 1)]),
        _: 1
      }, 8, ["disabled", "onClick"])])]),
      _: 1
    })]),
    _: 1
  }, 8, ["model", "rules"]), _hoisted_52, _createElementVNode("div", _hoisted_53, [_createVNode(_component_a_button, {
    class: "button-default loginBtn",
    color: "#000000",
    onClick: $setup.onCheckResetPasswordNext
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("login.nextStep")), 1)]),
    _: 1
  }, 8, ["onClick"])]), _hoisted_54, _hoisted_55])])], 512), [[_vShow, $setup.control.loginTab === 3 && $setup.control.resetPasswordStep === 0]]), _withDirectives(_createElementVNode("div", _hoisted_56, [_createElementVNode("div", _hoisted_57, [_createElementVNode("div", null, _toDisplayString(_ctx.$t("login.resetPassword")), 1)]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_58, [_createVNode(_component_a_form, {
    ref: "resetPasswordNextForm",
    model: $setup.resetPasswordFormData,
    rules: $setup.resetPasswordFormRules
  }, {
    default: _withCtx(() => [_createVNode(_component_a_form_item, {
      class: "password-email",
      label: "",
      name: "password"
    }, {
      default: _withCtx(() => [_hoisted_59, _createVNode(_component_a_input, {
        value: $setup.resetPasswordFormData.password,
        "onUpdate:value": _cache[31] || (_cache[31] = $event => $setup.resetPasswordFormData.password = $event),
        type: "password",
        placeholder: _ctx.$t('login.enterNewPassword'),
        size: "large"
      }, null, 8, ["value", "placeholder"])]),
      _: 1
    }), _createVNode(_component_a_form_item, {
      label: "",
      name: "passwordAgain"
    }, {
      default: _withCtx(() => [_hoisted_60, _createVNode(_component_a_input, {
        value: $setup.resetPasswordFormData.passwordAgain,
        "onUpdate:value": _cache[32] || (_cache[32] = $event => $setup.resetPasswordFormData.passwordAgain = $event),
        type: "password",
        placeholder: _ctx.$t('login.confirmPassword'),
        size: "large"
      }, null, 8, ["value", "placeholder"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["model", "rules"]), _hoisted_61, _createElementVNode("div", _hoisted_62, [_createVNode(_component_a_button, {
    class: "button-default loginBtn",
    color: "#000000",
    onClick: $setup.onResetPassword
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("login.nextStep")), 1)]),
    _: 1
  }, 8, ["onClick"])]), _hoisted_63, _hoisted_64])])], 512), [[_vShow, $setup.control.loginTab === 3 && $setup.control.resetPasswordStep === 1]]), _withDirectives(_createElementVNode("div", _hoisted_65, [_createElementVNode("div", _hoisted_66, [_createElementVNode("div", null, _toDisplayString(_ctx.$t("login.resetPassword")), 1)]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.$t("login.passwordSuccess")), 1), _hoisted_69, _createElementVNode("div", _hoisted_70, [_createVNode(_component_a_button, {
    class: "button-default loginBtn",
    color: "#000000",
    onClick: $setup.loginClick
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("login.backLogin")), 1)]),
    _: 1
  }, 8, ["onClick"])]), _hoisted_71, _hoisted_72])])], 512), [[_vShow, $setup.control.loginTab === 3 && $setup.control.resetPasswordStep === 2]]), _withDirectives(_createElementVNode("div", _hoisted_73, [_createElementVNode("div", _hoisted_74, [_createElementVNode("div", _hoisted_75, [_createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.$t("login.scanLogin")), 1), _hoisted_77, _createElementVNode("div", _hoisted_78, [_createElementVNode("span", {
    onClick: _cache[33] || (_cache[33] = $event => $setup.loginClick()),
    style: {
      "cursor": "pointer"
    }
  }, _toDisplayString(_ctx.$t("login.passwordLogin")), 1)])])]), _hoisted_79], 512), [[_vShow, $setup.control.loginTab === 4]]), _withDirectives(_createElementVNode("div", _hoisted_80, [_createElementVNode("div", _hoisted_81, [_createElementVNode("div", _hoisted_82, [_createElementVNode("div", _hoisted_83, _toDisplayString(_ctx.$t("login.bindMobile")), 1), _createElementVNode("div", _hoisted_84, _toDisplayString($setup.mobileCheckControl.message), 1)]), _hoisted_85]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_86, [_createVNode(_component_el_form, {
    ref: "mobileCheckForm",
    model: $setup.mobileCheckFormData,
    rules: $setup.mobileCheckFormRules
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      prop: "mobile"
    }, {
      default: _withCtx(() => [_hoisted_87, _createVNode(_component_el_input, {
        modelValue: $setup.mobileCheckFormData.mobile,
        "onUpdate:modelValue": _cache[34] || (_cache[34] = $event => $setup.mobileCheckFormData.mobile = $event),
        placeholder: _ctx.$t('login.enterMobileNumber'),
        size: "large",
        onInput: $setup.mobileInput
      }, null, 8, ["modelValue", "placeholder", "onInput"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      prop: "smsCode"
    }, {
      default: _withCtx(() => [_hoisted_88, _createElementVNode("div", _hoisted_89, [_createVNode(_component_el_input, {
        modelValue: $setup.mobileCheckFormData.smsCode,
        "onUpdate:modelValue": _cache[35] || (_cache[35] = $event => $setup.mobileCheckFormData.smsCode = $event),
        placeholder: _ctx.$t('login.code'),
        size: "large",
        style: {
          "flex": "1",
          "margin-right": "10px"
        }
      }, null, 8, ["modelValue", "placeholder"]), _createVNode(_component_el_button, {
        style: {
          "width": "140px",
          "height": "42px"
        },
        disabled: $setup.mobileCheckControl.smsDisabled,
        onClick: $setup.onSendMobileCheckSms
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.mobileCheckControl.smsButtonText), 1)]),
        _: 1
      }, 8, ["disabled", "onClick"])])]),
      _: 1
    })]),
    _: 1
  }, 8, ["model", "rules"]), _hoisted_90, _createVNode(_component_el_button, {
    style: {
      "width": "100%",
      "height": "42px"
    },
    class: "button-default",
    color: "#000000",
    onClick: $setup.onWxBind
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.mobileCheckControl.buttonText), 1)]),
    _: 1
  }, 8, ["onClick"]), _hoisted_91, _createElementVNode("div", _hoisted_92, [_createVNode(_component_el_checkbox, {
    modelValue: $setup.loginFormData.remember,
    "onUpdate:modelValue": _cache[36] || (_cache[36] = $event => $setup.loginFormData.remember = $event),
    label: _ctx.$t('login.autoLogin'),
    size: "large"
  }, null, 8, ["modelValue", "label"])])])])], 512), [[_vShow, $setup.control.loginTab === 5]]), _createElementVNode("div", _hoisted_93, [_withDirectives(_createElementVNode("div", {
    onClick: _cache[37] || (_cache[37] = $event => $setup.control.loginTab = 0)
  }, [_createVNode(_component_LeftCircleOutlined, {
    style: {
      "font-size": "22px",
      "color": "#8b8b8b",
      "margin-right": "5px"
    }
  }), _createTextVNode(_toDisplayString(_ctx.$t("login.backToLogin")), 1)], 512), [[_vShow, $setup.control.loginTab === 1 || $setup.control.loginTab === 2]]), _withDirectives(_createElementVNode("div", {
    onClick: _cache[38] || (_cache[38] = $event => $setup.control.loginTab = 1)
  }, _toDisplayString(_ctx.$t("login.newAccount")), 513), [[_vShow, $setup.control.loginTab === 0 || $setup.control.loginTab === 3 || $setup.control.loginTab === 4]])])])])], 512)], 64);
}